import { brand } from '../brand/brand';

// Ð¦Ð²ÐµÑÐ° Ð±ÑÐµÐ½Ð´Ð° (cameo, armadillo, rowYellowBG) Ð±ÐµÑÑÑÑÑ Ð¸Ð· Ð¿Ð°Ð»Ð¸ÑÑÑ ÑÐ±Ð¾ÑÐºÐ¸:
// DOSCAR Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ, Horizon Ð´Ð»Ñ Rox Ð¸ JetQ (REACT_APP_BRAND=horizon).
export const colors = {
  lightGrey: '#BABABA',
  cameo: brand.primary,
  dimGray: '#6A6A6A',
  blackPearl: '#05141F',
  alto: '#D9D9D9',
  white: '#FFFFFF',
  armadillo: brand.dark,
  backgroung: '#FBFBFB',
  disabled: '#ededed',
  statusGreen: '#71B183',
  rowRedBG: '#ff00001c',
  rowYellowBG: brand.row,
  red: '#EB5757',
  green: '#71B183',
  orange: '#FF8C00',
};
